export enum SystemActivityNavTabsParams {
   MEDICAL_DATA_ACCESS = 'dostep-do-danych-medycznych',
}
